// Une phrase par formation : ce qu'elle apporte à quelqu'un qui travaille seul.
//
// La description du catalogue (lib/courses-catalog.js) parle technique et sert
// aux moteurs de recherche. Celle-ci sert aux cartes courtes : le catalogue de
// /formations et « Pour aller plus loin » sur le tableau de bord. En français
// seulement, comme les formations.

export const COURSE_PITCHES = {
    "formation-n8n": "Automatisez ce qui vous prend du temps, sans écrire de code.",
    "formation-claude-code": "Faites écrire votre code par Claude, en comprenant ce qu'il produit.",
    "formation-hermes-agent": "Un agent installé chez vous, qui vous répond depuis vos messageries.",
    "formation-python": "Scripts, robots et analyse de données : le langage qui sert à tout automatiser.",
    "formation-claude-design": "Des interfaces et des visuels professionnels, conçus avec Claude.",
    "formation-claude-cowork": "Déléguez à Claude la rédaction, l'analyse et les tâches du quotidien.",
    "formation-codex": "Codex lit votre projet et écrit les modifications, vous validez.",
    "formation-html": "Votre premier site, fait de vos mains, et un portfolio pour montrer votre travail.",
    "mettre-son-site-en-ligne-facilement": "Votre site en ligne, avec une adresse e-mail à votre nom.",
    "formation-javascript": "Rendez vos sites interactifs, en partant de zéro.",
    "formation-git-github": "Gardez chaque version de votre site et revenez en arrière en un clic.",
    "formation-php": "Stockez et gérez les données de vos sites.",
    "formation-bootstrap": "Des pages professionnelles sans partir d'une feuille blanche.",
    "formation-tailwindcss": "Des interfaces soignées, claires ou sombres, en peu de temps.",
    "formation-sass": "Écrivez vos feuilles de style plus vite.",
    "formation-typescript": "Un JavaScript plus sûr et plus facile à faire évoluer.",
    "formation-mvc": "Organisez le code de vos sites pour qu'il dure.",
    "formation-react": "Des interfaces modernes, apprises sur des projets concrets.",
    "formation-nextjs": "Des sites complets, rapides et bien référencés.",
    "formation-react-native": "Vos applications mobiles, écrites en JavaScript.",
    "formation-symfony": "Un site e-commerce complet, du catalogue au paiement.",
    "formation-nodejs": "Vos applications côté serveur, en JavaScript.",
    "formation-angular": "Des applications web modernes avec Angular.",
    "maitriser-son-nas-synology": "Sauvegardes, cloud et partage : votre NAS bien réglé.",
};

/** La phrase d'une formation, ou null (formation inconnue, ou autre langue que le français). */
export function getCoursePitch(slug, locale = "fr") {
    return locale === "fr" ? COURSE_PITCHES[slug] || null : null;
}
